import moment from 'moment'
import Vue from 'vue';

/**
 * Format UTC Date
 * Default format: 'DD.MM.YYYY'
 */
export function formatUtcDate (utcDate, format = 'DD.MM.YYYY') {
    moment.locale("ro")
    return moment.utc(utcDate).format(format);
}

/**
 * Format URL - Remove http, https
 */
export function formatUrl (url, addWww) {
    let urlFormated = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
    if(addWww) {
        return 'www.' + urlFormated
    } else {
        return urlFormated
    }
}

/**
 * Limit Words from string
 * @parameters: string, words number
 */

export function limitWords (string, words) {
    var totalWords = string.split(' ').length;
    return string.split(" ").splice(0, words).join(" ") + (words < totalWords ? '...' : '')
}

export function escapeHTML (string) {
    if(string && string.length > 0)
        return string.replace("<", "&lt;");
}

export function notify(message, options = {}) {
    Vue.$toast.open({
        message,
        type: 'default',
        duration: 12000,
        position: (screen.width < 992) ? 'bottom' : 'bottom-right',
        ...options,
    });
}

/**
 * Depending on the event, changes the route or not.
 * @param event
 * @param next
 */
export function changeRoute(event, next){
    if(event){
        next();
    }
    else{
        next(false);
    }
}

/**
 * Checks if there is any input with value from the entire page.
 */
export function checkFormForInputs(initialInputs = null) {
    let inputs = document.getElementsByTagName('input');

    if(initialInputs){
        if (initialInputs.length === inputs.length){
            for(let index = 0; index < inputs.length; index++){
                if(initialInputs[index] !== inputs[index]){
                    return true;
                }
            }
        }
        else {
            return true;
        }
    }

    for(let i=0; i < inputs.length; i++){
        if (inputs[i].value && inputs[i].type !== 'checkbox' && inputs[i].type !== 'radio'){
            return true;
        }
    }

    return false;
}
/**
 * Check if current user has admin role
 */
export function isAdmin () {
    return this.$store.getters['auth/user'].role === "Admin";
}

/**
 * @param text
 * @param limit
 * @param withDiacriticsNumber
 *
 * returns the number of characters remaining until the limit is reached.
 *
 *      !!! Diacritics are counted for 2 characters
 */
export function charactersRemaining(text, limit, withDiacriticsNumber = false){
    let diacritics = ['ă','Ă','î','Î','â','Â','ș','Ș','ț','Ț'];
    let diacriticsNumber = 0;
    let count = 0;

    for(let i = 0; i < text.length; i++){
        if(diacritics.includes(text.charAt(i))){
            count += 2;
            diacriticsNumber++;
        }
        else{
            count ++;
        }
    }
    if(withDiacriticsNumber){
        return {
            limit: limit - count,
            diacriticsUsed: diacriticsNumber
        };
    }
    else
        return limit - count;
}
